/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Validation functions for MOH Sources forms.
────────────────────────────────────────────────────────────────*/

import { MOHSourceFormData } from '../types';

export interface ValidationErrors {
  [key: string]: string;
}

/**
 * Validate MOH Source form data
 */
export function validateMohSourceForm(
  data: MOHSourceFormData,
  selectedFiles: File[],
  isEditMode: boolean,
): ValidationErrors {
  const errors: ValidationErrors = {};

  if (!data.name?.trim()) {
    errors.name = 'Name is required';
  }

  if (!data.source_path && data.source_type !== 'file') {
    errors.source_path = 'Source path is required';
  }

  if (data.source_type === 'file' && selectedFiles.length === 0 && !isEditMode) {
    errors.files = 'At least one file is required for file sources';
  }

  return errors;
}

/**
 * Validate file type
 */
export function isValidAudioFile(file: File): boolean {
  const allowedExts = ['.wav', '.mp3', '.ogg'];
  const ext = '.' + file.name.split('.').pop()?.toLowerCase();
  return allowedExts.includes(ext);
}

/**
 * Validate file size (max 100MB)
 */
export function isValidFileSize(file: File, maxSizeMB: number = 100): boolean {
  const maxSize = maxSizeMB * 1024 * 1024;
  return file.size <= maxSize;
}

